import React from "react";
import "../../assests/css/AboutUs.css";

const AboutUs = () => {
    return (
        <div className="prime-about-page">

            {/* =====================================================
                HERO SECTION
            ===================================================== */}

            <section className="prime-about-hero">

                <div className="prime-hero-overlay"></div>

                <div className="prime-about-hero-content">

                    <span className="prime-about-label">
                        PRIME LUXURY PASSENGER TRANSPORT LLC
                    </span>

                    <h1>
                        Premium Chauffeur Service in Dubai
                    </h1>

                    <p>
                        Experience professional chauffeur-driven
                        limousine transportation for business travel,
                        airport transfers, VIP journeys and special
                        occasions across Dubai and the UAE.
                    </p>

                    <div className="prime-about-buttons">

                        <a
                            href="#chauffeur-services"
                            className="prime-primary-button"
                        >
                            Explore Chauffeur Services
                        </a>

                        <a
                            href="https://www.dxblimo.com/"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="prime-secondary-button"
                        >
                            Visit Our Website
                        </a>

                    </div>

                </div>


                {/* Animated Vehicle */}

                {/* <div className="prime-animated-car">

                    <div className="car-light-effect"></div>

                    <img
                        src="/images/prime-luxury/limousine.png"
                        alt="Prime Luxury chauffeur limousine in Dubai"
                    />

                </div> */}


                {/* Road / Glow */}

                <div className="prime-road-glow"></div>

            </section>


            {/* =====================================================
                INTRODUCTION
            ===================================================== */}

            <section className="prime-about-section">

                <div className="prime-container">

                    <div className="prime-intro-grid">

                        <div className="prime-intro-content">

                            <span className="prime-section-label">
                                ABOUT PRIME LUXURY
                            </span>

                            <h2>
                                Luxury Chauffeur Transportation
                                Designed Around You
                            </h2>

                            <p>
                                Prime Luxury Passenger Transport LLC
                                provides professional chauffeur and
                                limousine transportation services in
                                Dubai and across the UAE.
                            </p>

                            <p>
                                Our focus is to provide a smooth,
                                comfortable and professional travel
                                experience for every passenger. From
                                airport transfers and corporate travel
                                to VIP transportation and special
                                events, our chauffeur services are
                                designed for customers who value
                                comfort, reliability and exceptional
                                service.
                            </p>

                            <p>
                                With premium vehicles and professional
                                chauffeurs, Prime Luxury provides a
                                refined transportation experience for
                                both individuals and corporate clients.
                            </p>

                        </div>


                        <div className="prime-intro-highlight">

                            <div className="highlight-card">

                                <div className="highlight-icon">
                                    🚘
                                </div>

                                <h3>
                                    Premium Chauffeur Experience
                                </h3>

                                <p>
                                    Professional chauffeur-driven
                                    transportation for a comfortable
                                    and seamless journey.
                                </p>

                            </div>


                            <div className="highlight-card">

                                <div className="highlight-icon">
                                    ✦
                                </div>

                                <h3>
                                    Luxury & Comfort
                                </h3>

                                <p>
                                    Carefully selected premium vehicles
                                    for executive and VIP transportation.
                                </p>

                            </div>

                        </div>

                    </div>

                </div>

            </section>


            {/* =====================================================
                CHAUFFEUR SERVICES
            ===================================================== */}

            <section
                className="prime-about-section prime-services-section"
                id="chauffeur-services"
            >

                <div className="prime-container">

                    <div className="prime-section-heading">

                        <span className="prime-section-label">
                            OUR CHAUFFEUR SERVICES
                        </span>

                        <h2>
                            Professional Limousine Services
                            in Dubai
                        </h2>

                        <p>
                            Premium chauffeur transportation
                            solutions for business, leisure and
                            special occasions.
                        </p>

                    </div>


                    <div className="prime-services-grid">

                        {/* Service 1 */}

                        <article className="prime-service-card">

                            <div className="prime-service-icon">
                                ✈
                            </div>

                            <h3>
                                Airport Transfers
                            </h3>

                            <p>
                                Enjoy a comfortable and professional
                                airport transfer with a chauffeur
                                ready to provide a smooth journey
                                between the airport and your destination.
                            </p>

                            <span className="service-number">
                                01
                            </span>

                        </article>


                        {/* Service 2 */}

                        <article className="prime-service-card">

                            <div className="prime-service-icon">
                                💼
                            </div>

                            <h3>
                                Corporate Chauffeur
                            </h3>

                            <p>
                                Executive transportation for meetings,
                                business appointments, corporate
                                events and daily business travel.
                            </p>

                            <span className="service-number">
                                02
                            </span>

                        </article>


                        {/* Service 3 */}

                        <article className="prime-service-card">

                            <div className="prime-service-icon">
                                👑
                            </div>

                            <h3>
                                VIP Chauffeur Service
                            </h3>

                            <p>
                                A refined chauffeur experience for
                                VIP guests, executives, high-profile
                                occasions and premium travel.
                            </p>

                            <span className="service-number">
                                03
                            </span>

                        </article>


                        {/* Service 4 */}

                        <article className="prime-service-card">

                            <div className="prime-service-icon">
                                🏙
                            </div>

                            <h3>
                                Dubai City Chauffeur
                            </h3>

                            <p>
                                Travel around Dubai in comfort with
                                professional chauffeur-driven
                                transportation available for your
                                daily requirements.
                            </p>

                            <span className="service-number">
                                04
                            </span>

                        </article>


                        {/* Service 5 */}

                        <article className="prime-service-card">

                            <div className="prime-service-icon">
                                💍
                            </div>

                            <h3>
                                Events & Occasions
                            </h3>

                            <p>
                                Premium transportation for weddings,
                                celebrations, exhibitions, corporate
                                events and special occasions.
                            </p>

                            <span className="service-number">
                                05
                            </span>

                        </article>


                        {/* Service 6 */}

                        <article className="prime-service-card">

                            <div className="prime-service-icon">
                                🌍
                            </div>

                            <h3>
                                UAE Chauffeur Travel
                            </h3>

                            <p>
                                Comfortable chauffeur transportation
                                for journeys between Dubai and other
                                destinations across the UAE.
                            </p>

                            <span className="service-number">
                                06
                            </span>

                        </article>

                    </div>

                </div>

            </section>


            {/* =====================================================
                WHY PRIME LUXURY
            ===================================================== */}

            <section className="prime-about-section prime-why-section">

                <div className="prime-container">

                    <div className="prime-why-grid">

                        <div className="prime-why-image">

                            <div className="prime-image-frame">

                                <div className="prime-image-content">

                                    <span>
                                        PRIME LUXURY
                                    </span>

                                    <strong>
                                        CHAUFFEUR
                                    </strong>

                                    <small>
                                        DUBAI · UAE
                                    </small>

                                </div>

                            </div>

                        </div>


                        <div className="prime-why-content">

                            <span className="prime-section-label">
                                WHY CHOOSE US
                            </span>

                            <h2>
                                Your Journey, Our Commitment
                            </h2>

                            <p>
                                At Prime Luxury Passenger Transport,
                                we believe that chauffeur service is
                                more than simply getting from one
                                destination to another.
                            </p>

                            <p>
                                Every journey is an opportunity to
                                provide comfort, professionalism and
                                dependable service.
                            </p>


                            <div className="prime-feature-list">

                                <div className="prime-feature">

                                    <span className="feature-check">
                                        ✓
                                    </span>

                                    <div>
                                        <h3>
                                            Professional Chauffeurs
                                        </h3>

                                        <p>
                                            Courteous and professional
                                            service throughout your
                                            journey.
                                        </p>
                                    </div>

                                </div>


                                <div className="prime-feature">

                                    <span className="feature-check">
                                        ✓
                                    </span>

                                    <div>
                                        <h3>
                                            Premium Vehicles
                                        </h3>

                                        <p>
                                            Luxury vehicles selected
                                            for comfort and executive
                                            travel.
                                        </p>
                                    </div>

                                </div>


                                <div className="prime-feature">

                                    <span className="feature-check">
                                        ✓
                                    </span>

                                    <div>
                                        <h3>
                                            Customer Focused
                                        </h3>

                                        <p>
                                            Service designed around
                                            your travel requirements.
                                        </p>
                                    </div>

                                </div>


                                <div className="prime-feature">

                                    <span className="feature-check">
                                        ✓
                                    </span>

                                    <div>
                                        <h3>
                                            Reliable Transportation
                                        </h3>

                                        <p>
                                            Dependable chauffeur
                                            transportation for important
                                            journeys.
                                        </p>
                                    </div>

                                </div>

                            </div>

                        </div>

                    </div>

                </div>

            </section>


            {/* =====================================================
                LUXURY FLEET
            ===================================================== */}

            <section className="prime-about-section prime-fleet-section">

                <div className="prime-container">

                    <div className="prime-section-heading">

                        <span className="prime-section-label">
                            OUR FLEET
                        </span>

                        <h2>
                            Travel in Premium Comfort
                        </h2>

                        <p>
                            Choose from a selection of premium
                            chauffeur-driven vehicles suitable for
                            different travel requirements.
                        </p>

                    </div>


                    <div className="prime-fleet-grid">

                        <div className="prime-fleet-card">

                            <div className="fleet-icon">
                                🚘
                            </div>

                            <h3>
                                Luxury Sedans
                            </h3>

                            <p>
                                Elegant executive sedans for corporate
                                and VIP transportation.
                            </p>

                        </div>


                        <div className="prime-fleet-card">

                            <div className="fleet-icon">
                                🚙
                            </div>

                            <h3>
                                Luxury SUVs
                            </h3>

                            <p>
                                Spacious premium SUVs for families,
                                executives and VIP guests.
                            </p>

                        </div>


                        <div className="prime-fleet-card">

                            <div className="fleet-icon">
                                🚐
                            </div>

                            <h3>
                                Luxury Vans
                            </h3>

                            <p>
                                Comfortable group transportation for
                                corporate and private journeys.
                            </p>

                        </div>

                    </div>

                </div>

            </section>


            {/* =====================================================
                COMMITMENT
            ===================================================== */}

            <section className="prime-commitment-section">

                <div className="prime-container">

                    <div className="prime-commitment-content">

                        <span className="prime-about-label">
                            OUR COMMITMENT
                        </span>

                        <h2>
                            Luxury Travel Redefined
                        </h2>

                        <p>
                            We are committed to delivering a chauffeur
                            experience that combines professional
                            service, premium vehicles and attention
                            to every journey.
                        </p>

                        <div className="prime-commitment-line"></div>

                    </div>

                </div>

            </section>


            {/* =====================================================
                CTA
            ===================================================== */}

            <section className="prime-about-cta">

                <div className="prime-container">

                    <div className="prime-cta-content">

                        <span className="prime-section-label">
                            EXPERIENCE PRIME LUXURY
                        </span>

                        <h2>
                            Ready for a Premium Chauffeur Experience?
                        </h2>

                        <p>
                            Book a professional chauffeur for your
                            next airport transfer, business journey,
                            VIP trip or special occasion in Dubai.
                        </p>

                        <div className="prime-cta-buttons">

                            <a
                                href="https://www.dxblimo.com/"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="prime-cta-primary"
                            >
                                Book Your Chauffeur
                            </a>

                            <a
                                href="https://www.dxblimo.com/"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="prime-cta-secondary"
                            >
                                www.dxblimo.com
                            </a>

                        </div>

                    </div>

                </div>

            </section>

        </div>
    );
};

export default AboutUs;